import makeSlice from '@web/slices/orderTotal/sliceMaker'

import {fetchDeliveryFee, fetchSubscription, restoreSubscription} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(fetchSubscription.fulfilled, (state, {payload: {subscriptionViewResult}}) => {
                const {
                    delivery,
                    amountInfo: {orderAmount, discountAmount},
                } = subscriptionViewResult

                state.amount = orderAmount

                state.deliveryFeeAmount = delivery.totalPrepayOrderDeliveryFee

                state.discountAmount = discountAmount
            })
            .addCase(fetchDeliveryFee.fulfilled, (state, {payload: {delivery}}) => {
                state.deliveryFeeAmount = delivery.totalPrepayOrderDeliveryFee
            })
            .addCase(restoreSubscription.fulfilled, (state, {payload}) => {
                state.deliveryFeeAmount = payload.storedState.orderTotal.deliveryFeeAmount
            })
    },
})

export default slice.reducer
